// Mock data for Naiwa Daughters website

export const projects = [
  {
    id: 1,
    title: "Rights of Nature",
    slug: "rights-of-nature",
    description: "Advocating for the legal rights of natural entities and environmental protection through Indigenous perspectives and leadership.",
    longDescription: "Our Rights of Nature initiative empowers young Indigenous women to become environmental advocates and stewards of Mother Earth. We work to advance legal frameworks that recognize the inherent rights of nature, drawing from Cherokee traditions of living in balance with the natural world.",
    image: "https://customer-assets.emergentagent.com/job_naiwa-family/artifacts/bs2swpbd_NAIWA%20Daughters%20sticker%20%20%20%283%29.png",
    impact: "50+ youth trained in environmental advocacy",
    status: "Active"
  },
  {
    id: 2,
    title: "Aun\"tea\" Time",
    slug: "auntea-time",
    description: "Creating safe spaces for Indigenous young women to gather, share stories, and build community through traditional Cherokee practices.",
    longDescription: "Aun\"tea\" Time provides a nurturing environment where young Indigenous women can connect with mentors, share experiences, and learn traditional practices. These gatherings focus on mental health, cultural preservation, and building lasting relationships.",
    image: "https://customer-assets.emergentagent.com/job_naiwa-family/artifacts/vr8rwrgb_AunTea%20Time%20swag%20%281%29.png",
    impact: "Monthly gatherings with 20+ participants",
    status: "Active"
  },
  {
    id: 3,
    title: "Softball for Sovereignty",
    slug: "softball-for-sovereignty",
    description: "Using athletics to build leadership, teamwork, and cultural pride while promoting Indigenous sovereignty and self-determination.",
    longDescription: "Softball for Sovereignty combines athletic development with cultural education and leadership training. Through team sports, participants learn valuable life skills while staying connected to their Cherokee heritage and advocating for Indigenous rights.",
    image: "https://customer-assets.emergentagent.com/job_naiwa-family/artifacts/4kq7oo8u_Cherokee%20Softball%20for%20sovereignty%20Initiative.png",
    impact: "25+ young athletes empowered",
    status: "Active"
  },
  {
    id: 4,
    title: "SHE-yo Project",
    slug: "she-yo-project",
    description: "Connecting young Indigenous women through intentional relationship building and modeling community leadership.",
    longDescription: "The SHE-yo Project is our newest initiative designed to connect young Indigenous women with each other, through intentional relationship building amplifying the significance of modeling community and selfless leadership.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80",
    impact: "Launching 2026",
    status: "Upcoming"
  }
];

export const youthLeaders = [
  {
    id: 1,
    name: "Jasmine Smith",
    role: "ND Founder and Chairwoman",
    age: 14,
    school: "Knoxville Montessori School",
    bio: "Jasmine is a passionate social justice and equality advocate. She is driven to ensure the next generation of Native women are heard, respected, and prepared to lead with confidence and purpose. \"I want to heal intergenerational trauma, not just for myself, but for those before me and those to come. We can build a future rooted in strength, culture, and resilience.\"",
    achievements: [
      "Founded first NAIWA Cherokee chapter",
      "Social justice advocate",
      "Intergenerational healing leader"
    ],
    image: "https://customer-assets.emergentagent.com/job_naiwa-family/artifacts/hs220k0a_jazz.png"
  },
  {
    id: 2,
    name: "Kyndra Postoak",
    role: "ND Secretary",
    age: 15,
    school: "Shining Rock Classical Academy",
    bio: "Kyndra is dedicated to uplifting heritage, especially for young women of multiple tribal citizenship. Passionate about Indigenous mental health, she strives to ensure Native youth are cared for and valued across Turtle Island. \"Our identities are rich, complex, and powerful. I want to uplift young Native women to embrace every part of who they are, to know that they matter.\"",
    achievements: [
      "Mental health advocate",
      "Multi-tribal citizenship advocate",
      "Cultural heritage educator"
    ],
    image: "https://via.placeholder.com/400x400/7e2f22/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 3,
    name: "Zailiana Blythe",
    role: "Communication Liaison",
    age: 13,
    school: "Jackson County Early College",
    bio: "Zai is focused on uplifting the mission and success of NAIWA Daughters and other Indigenous young women. She wants to ensure Native women have the empowerment to become the leaders we need.",
    achievements: [
      "Communications leader",
      "Indigenous women empowerment advocate",
      "Mission-driven organizer"
    ],
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/16y5qwdw_zailiana.jpg"
  },
  {
    id: 4,
    name: "Janee Smith",
    role: "Softball for Sovereignty Project Lead",
    age: 11,
    school: "Knoxville Montessori School",
    bio: "Janee is one of the youngest members on the leadership team. She is dedicated to bringing culture to sport and utilizing sport to showcase the leadership of Indigenous women. \"Sports can be a vehicle for more, we need to create pathways for young Indigenous women to grow into incredible leaders not just athletes.\"",
    achievements: [
      "Softball for Sovereignty leader",
      "Sports & culture integration",
      "Youth athletics advocate"
    ],
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/nbps9k1j_janee.jpg"
  },
  {
    id: 5,
    name: "Misha Slee",
    role: "Junior Miss Cherokee",
    age: 16,
    school: "Cherokee Middle School",
    bio: "Misha is a young Indigenous leader who has served her community as Junior Miss Cherokee. She brings a passion for building strong relationships between NAIWA members, Cherokee community, and young women in general.",
    achievements: [
      "Junior Miss Cherokee",
      "She-yo Project founder",
      "Community relationship builder"
    ],
    image: "https://via.placeholder.com/400x400/7e2f22/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 6,
    name: "Laila Taylor",
    role: "Aun\"Tea\" Time Project Lead",
    age: 14,
    school: "Cherokee High School",
    bio: "Laila loves being a part of communities providing safe spaces for young women. She wants to ensure young women feel valued and seen. She brings a sense of urgency to build intergenerational communities for her tribe.",
    achievements: [
      "Aun\"Tea\" Time coordinator",
      "Safe spaces advocate",
      "Intergenerational community builder"
    ],
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/zt0eid0i_laila.jpg"
  }
];

export const adultMentors = [
  {
    id: 1,
    name: "Kimberly Smith",
    role: "ND Mentor",
    bio: "Kim is an expert in community organizing and Indigenous advocacy. She is passionate about the next generation reconnecting to their heritage and fostering their leadership. \"I hope for a future where Tribal leadership is gender balance. Young Indigenous women should see themselves as vital decision-makers, know their voices matter, and their contributions shape our Nation's future.\"",
    expertise: ["Community Organizing", "Indigenous Advocacy", "Leadership Development"],
    image: "https://customer-assets.emergentagent.com/job_naiwa-family/artifacts/mmzc4y9p_Kim%20Smith%20headshot.jpg"
  },
  {
    id: 2,
    name: "Malia Crowe",
    role: "ND Mentor",
    bio: "Malia is a dedicated mentor, educator, and advocate for cultural preservation. She is passionate about sharing Cherokee traditions and empowering young Indigenous women to embrace their heritage and leadership potential.",
    expertise: ["Cultural Preservation", "Cherokee Traditions", "Youth Education"],
    image: "https://via.placeholder.com/400x400/53a5ca/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 3,
    name: "Katie Tiger",
    role: "ND Mentor",
    bio: "Katie is a former collegiate softball player who strives to use sports to build bridges for Indigenous young women to greater leadership opportunities. She brings her athletic experience and passion for empowering young women through sports.",
    expertise: ["Collegiate Athletics", "Sports Leadership", "Youth Mentorship"],
    image: "https://via.placeholder.com/400x400/53a5ca/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 4,
    name: "Tia Panther",
    role: "ND Mentor",
    bio: "Tia is a recent SCAD graduate who's passionate about uplifting Native voices through film, photography and social media. She encourages young Indigenous women to find their voice and let the world know that Indigenous People are still here.",
    expertise: ["Film", "Photography", "Social Media", "Native Storytelling"],
    image: "https://via.placeholder.com/400x400/53a5ca/ffffff?text=Photo+Coming+Soon"
  }
];

export const communityMembers = [
  {
    id: 1,
    name: "Story Martens",
    role: "ND Member",
    bio: "Story brings creativity, confidence, and team spirit into every NAIWA Daughters space, helping strengthen peer leadership and belonging.",
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/9rgpfj91_story.jpg"
  },
  {
    id: 2,
    name: "Aryahnie Pheasant",
    role: "ND Member",
    bio: "Aryahnie helps carry the Collective’s mission forward with warmth, curiosity, and a clear commitment to community-centered growth.",
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/j7kvk8az_aryahnie.jpg"
  },
  {
    id: 3,
    name: "Marijane Tafoya",
    role: "ND Member",
    bio: "Marijane brings grounded presence and strong peer support to Collective activities, helping create welcoming spaces for young Indigenous women.",
    image: "https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/ngzz0ocz_marijane.jpg"
  },
  {
    id: 4,
    name: "Nahnie George",
    role: "ND Member",
    bio: "Nahnie represents the next generation of NAIWA Daughters leadership by showing up with purpose, consistency, and love for community work.",
    image: "https://via.placeholder.com/400x400/7e2f22/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 6,
    name: "Lilly Pheasant",
    role: "ND Member",
    bio: "Lilly’s member profile space is ready and can be updated with a photo and custom bio whenever you share them.",
    image: "https://via.placeholder.com/400x400/7e2f22/ffffff?text=Photo+Coming+Soon"
  },
  {
    id: 7,
    name: "Gia Crowe-Taylor",
    role: "ND Member",
    bio: "Gia’s member profile space is ready and can be updated with a photo and custom bio whenever you share them.",
    image: "https://via.placeholder.com/400x400/7e2f22/ffffff?text=Photo+Coming+Soon"
  }
];

export const events = [
  {
    id: 1,
    title: "Quarterly Cultural Activity - Traditional Plant Harvesting",
    date: "2026-03-21",
    time: "9:00 AM - 5:00 PM",
    location: "Qualla Java Coffee Shop, Cherokee, NC",
    description: "Ramp foraging led by ND member, followed by traditional dinner teaching led by ND mentor.",
    type: "Cultural",
    status: "Upcoming"
  },
  {
    id: 2,
    title: "Corn Husk Doll Making",
    date: "2026-04-18",
    time: "1:00 PM - 3:00 PM",
    location: "TBD",
    description: "Cultural activity learning traditional corn husk doll making techniques.",
    type: "Cultural",
    status: "Upcoming"
  },
  {
    id: 3,
    title: "Aun\"tea\" Time",
    date: "2026-04-26",
    time: "2:00 PM - 4:00 PM",
    location: "Via Zoom (link coming soon)",
    description: "Virtual gathering for Indigenous young women to connect, share, and learn in a safe and supportive environment.",
    type: "Social",
    status: "Upcoming"
  },
  {
    id: 4,
    title: "Softball for Sovereignty Clinic",
    date: "2026-03-22",
    time: "12:00 PM - 2:00 PM",
    location: "Cherokee Fitness Center, Cherokee, NC",
    description: "Weekly softball clinics every Sunday through 4/26/26. Building athletic skills and cultural pride.",
    type: "Service",
    status: "Recurring"
  },
  {
    id: 5,
    title: "Annual Women's Luncheon",
    date: "2026-05-26",
    time: "12:00 PM - 1:00 PM",
    location: "TBD",
    description: "An intergenerational lunch opportunity to share time with elders and community leaders, and to honor women from the community ND members look up to.",
    type: "Social",
    status: "Upcoming"
  },
  {
    id: 6,
    title: "Bioneers Conference",
    date: "2026-03-24",
    dateEnd: "2026-03-28",
    time: "All Day",
    location: "California",
    description: "March 24-28, 2026. Chairwoman will be providing a keynote address and serving on a panel. ND members will serve on a panel and be interviewed on a podcast.",
    type: "Conference",
    status: "Upcoming"
  },
  {
    id: 7,
    title: "Society for Ethnobiology Conference",
    date: "2026-05-20",
    time: "All Day",
    location: "Tennessee",
    description: "Members will share Rights of Nature project strategies and successes.",
    type: "Conference",
    status: "Upcoming"
  },
  {
    id: 8,
    title: "Inter-Tribal Rights of Rivers Alliance (IROR) Gathering",
    date: "2026-05-22",
    time: "All Day",
    location: "Oklahoma",
    description: "ND member will share in Rights of Nature Dialogues and help develop strategies for implementations.",
    type: "Conference",
    status: "Upcoming"
  },
  {
    id: 9,
    title: "Intertribal Cultural Exchange",
    date: "2026-07-24",
    time: "All Day",
    location: "Montana",
    description: "ND members will share about their organization and priority projects and participate in cultural exchange ceremonies with local tribal nations.",
    type: "Conference",
    status: "Upcoming"
  },
  {
    id: 10,
    title: "Turtle Island Bioregional Congress 11",
    date: "2026-09-13",
    time: "All Day",
    location: "Oregon",
    description: "Members will share Rights of Nature project strategies and successes.",
    type: "Conference",
    status: "Upcoming"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Groundbreaking Women-Led Rights of Nature Resolution Passed by Eastern Band Cherokee",
    excerpt: "Eastern Band of Cherokee Indians passes historic resolution recognizing the rights of nature, led by NAIWA Daughters youth advocacy.",
    author: "Earth Law Center",
    date: "2026-01-15",
    category: "Rights of Nature",
    image: "https://images.squarespace-cdn.com/content/v1/55914fd1e4b01fb0b851a814/32551cbd-d57b-4808-9a8c-02ad319f1aeb/NAIWA+Daughters.jpg",
    content: "Eastern Band of Cherokee Indians passes historic resolution...",
    externalLink: "https://www.earthlawcenter.org/blog-entries/2026/1/groundbreaking-women-led-rights-of-nature-resolution-passed-by-eastern-band-cherokee"
  },
  {
    id: 2,
    title: "Eastern Band of Cherokee Resolution - Rights of Nature",
    excerpt: "Bioneers highlights the groundbreaking Rights of Nature resolution championed by NAIWA Daughters and Cherokee leadership.",
    author: "Bioneers",
    date: "2026-01-10",
    category: "Environmental Justice",
    image: "https://bioneers.org/wp-content/uploads/2026/01/615241303_17953236855063323_1332476443537338444_n.png",
    content: "Bioneers celebrates this historic moment...",
    externalLink: "https://bioneers.org/eastern-band-of-cherokee-resolution/"
  },
  {
    id: 3,
    title: "Outdoor Economy Conference Considers Investment in Recovery",
    excerpt: "NAIWA Daughters participates in outdoor economy discussions, bringing Indigenous youth perspectives to economic development.",
    author: "Citizen Times",
    date: "2025-09-27",
    category: "Community Impact",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
    content: "Conference explores investment opportunities...",
    externalLink: "https://www.citizen-times.com/story/news/local/2025/09/27/outdoor-economy-conference-considers-investment-in-recovery/86343345007/"
  },
  {
    id: 4,
    title: "Keep Tennessee River Beautiful Awards Recognition",
    excerpt: "NAIWA Daughters recognized for environmental stewardship and community service in keeping waterways clean and protected.",
    author: "Keep TN River Beautiful",
    date: "2026-03-01",
    category: "Awards",
    image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&q=80",
    content: "Recognition for environmental conservation efforts...",
    externalLink: "https://www.keeptnriverbeautiful.org/awards"
  },
  {
    id: 5,
    title: "A Safe Haven: Junior NAIWA Cherokee Group Breaking New Ground",
    excerpt: "The Cherokee One Feather features NAIWA Daughters as the first Junior NAIWA chapter in the country, creating safe spaces for Indigenous young women.",
    author: "The Cherokee One Feather",
    date: "2024-02-20",
    category: "Leadership",
    image: "https://theonefeather.com/library/uploads/2024/02/Junior-NAIWA-group-copy-scaled-e1708441787654.jpg",
    content: "First Junior NAIWA Cherokee chapter breaks new ground...",
    externalLink: "https://theonefeather.com/2024/02/20/a-safe-haven-junior-naiwa-cherokee-group-breaking-new-ground/"
  }
];

export const impactStats = [
  {
    number: "15+",
    label: "Active Members",
    icon: "Users"
  },
  {
    number: "4",
    label: "Priority Projects",
    icon: "Target"
  },
  {
    number: "450+",
    label: "Service Hours/Year",
    icon: "Heart"
  },
  {
    number: "1st",
    label: "NAIWA Daughters Collective",
    icon: "Award"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "I like it because it's really helping me be more confident when I speak and not worrying about what other people think. And just bonding, making new friendships from different schools.",
    author: "Kylana Sampson",
    role: "Member, Age 13"
  },
  {
    id: 2,
    quote: "Without this group, I feel like we wouldn't have as many girls who know about a lot of our traditions. This group has given us opportunities, and I'd like to pass that on to girls my sister's age in a few years.",
    author: "Kyndra Postoak",
    role: "Teen Miss Cherokee"
  },
  {
    id: 3,
    quote: "This has been a group where these girls can put aside differences. Here they can be themselves and feel comfortable with who they are and just interacting in that way.",
    author: "Kimberly Smith",
    role: "NAIWA Mentor"
  }
];
